<div class="splash-container">
    <ng-container [ngSwitch]="currentSection">
        <lgv-getting-started-section class="section-body" *ngSwitchCase="StepSection.GettingStarted"
            (closeDialog)="onClose()" (sectionChange)="goToSection($event)"
            [specificStep]="specificStep"></lgv-getting-started-section>
        <lgv-about-you-section class="section-body" *ngSwitchCase="StepSection.AboutYou"
            (sectionChange)="goToSection($event)" [specificStep]="specificStep"></lgv-about-you-section>
        <lgv-property-section class="section-body" *ngSwitchCase="StepSection.Property"
            (sectionChange)="goToSection($event)" [specificStep]="specificStep"></lgv-property-section>
        <lgv-income-and-assets-section class="section-body" *ngSwitchCase="StepSection.IncomeAndAssets"
            (sectionChange)="goToSection($event)" [specificStep]="specificStep"></lgv-income-and-assets-section>
        <lgv-submit-section class="section-body" *ngSwitchCase="StepSection.Submit"
            (closeDialog)="onClose()" (sectionChange)="goToSection($event)"></lgv-submit-section>
    </ng-container>
</div>